import { useState } from 'react'
import Text from '../../../../components/Text'
import anayaImgUrls from '../../../../constants/anaya-constants'
import whiteCurveBg from '../../../../assets/images/programs/nivolumab/curve-white.svg'

const WhyAnayaCare = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handlePlayVideo = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <section className="pb-[41px] rounded-b-[30px] why-anaya-care-bg">
      <img
        src={whiteCurveBg}
        alt="nivolumab-hero"
        className="w-full object-cover mb-7"
      />
      <div className="px-5 space-y-7">
        <Text tag="p" variant="headline" size="large" className="text-white">
          Why oncologists recommend Anaya Care?
        </Text>

        <Text
          tag="p"
          variant="body"
          size="large"
          className="text-white opacity-[0.7]"
        >
          Recognising the difficulties encountered by cancer patients and
          caregivers, Anaya Care is a support program tailored to address their
          specific needs.
        </Text>

        {/* video section */}
        <div className="max-w-[420px] mx-auto relative bg-[#8077B7] rounded-2xl pb-2">
          <div
            className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 hidden"
            onClick={handlePlayVideo}
          >
            <img
              src={anayaImgUrls.video.playIcon}
              alt="play"
              className="w-14 h-14"
            />
          </div>
          <img src={anayaImgUrls.video.thumbnail} alt="viemax-stories" />
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center h-screen z-[999]">
          <div className="bg-white py-4 px-1 rounded h-[calc(100vh-100px)] w-[calc(100vw-20px)] overflow-hidden">
            <div className="flex justify-end pb-1">
              <button onClick={handleCloseModal} className="text-red-500">
                Close
              </button>
            </div>
            <iframe
              className="h-[calc(100%-20px)] w-full"
              src={anayaImgUrls.video.videoUrl}
              title={anayaImgUrls.video.title}
              frameborder="0"
              allow="autoplay; clipboard-write; encrypted-media; gyroscope;"
              allowfullscreen
              style={{ aspectRatio: '16/9' }}
            />
          </div>
        </div>
      )}
    </section>
  )
}

export default WhyAnayaCare

// {
//   /* <div
//   style={{
//     backgroundImage: `url(${whyAnayaCareBg})`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     backgroundRepeat: 'no-repeat',
//   }}
// ></div> */
// }
